import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { LogoMark } from '@/components/brand/LogoMark'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <LogoMark size={48} className="mx-auto mb-4 animate-spin [animation-duration:1.6s]" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />
  }

  return <>{children}</>
}
